import {Inject, Injectable} from '@angular/core';

import { AuthStoreService } from './auth-store.service';
import {OKTA_AUTH, OktaAuthStateService} from '@okta/okta-angular';
import OktaAuth, {AuthState} from '@okta/okta-auth-js';
import {filter, map} from 'rxjs/operators';
import {BehaviorSubject, forkJoin, of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AuthFacadeService {
    isAuthenticated$ = this._oktaStateService.authState$.pipe(
        filter((s: AuthState) => !!s),
        map((s: AuthState) => s.isAuthenticated ?? false)
    );
    testingRole$ = new BehaviorSubject<string>(null);
    isReadOnly$ = this.authStore.queries.isReadOnly$.pipe(
        map((isReadOnly) => isReadOnly = isReadOnly || (this.testingRole$.value ? this.testingRole$.value === 'LOGIN' : false))
    );
    status$ = this.authStore.queries.status$;
    user$ = this.authStore.queries.user$;

    constructor(
        private authStore: AuthStoreService,
        private _oktaStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth,) {}



    authenticateUser() {
        this.authStore.dispatch.authenticateUser();
    }

    signOut() {
        this.authStore.dispatch.signOut();
    }

    getAuthToken() {
        const oktaTokenString = sessionStorage.getItem('okta-token-storage');
        const oktaTokenJSON = JSON.parse(oktaTokenString);
        return oktaTokenJSON.idToken?.idToken;
    }

    async renewToken(key: string): Promise<void> {
        await this._oktaAuth.tokenManager.renew(key);
    }

}
